import axios from "axios";
import { API_ENDPOINTS } from "@/services/config";

function buildHeaders(entraId) {
  return {
    "Content-Type": "application/json",
    ...(entraId ? { "entra-id": entraId } : {}),
  };
}

export async function listEntityMdLists(assType, assId, entraId) {
  if (assType === "record") {
    const response = await axios.get(API_ENDPOINTS.recordMdlists, {
      params: { record_id: assId, entra_id: entraId },
    });
    return response.data;
  }

  if (assType === "experiment") {
    const response = await axios.get(API_ENDPOINTS.experimentMdlists, {
      params: { node_id: assId, entra_id: entraId },
    });
    return response.data;
  }

  throw new Error(`Metadata list bindings are not supported for entity type: ${assType}`);
}

export async function attachMdListToEntity(assType, assId, mdlistId, entraId) {
  if (assType === "record") {
    const response = await axios.post(API_ENDPOINTS.recordMdlists, {
      record_id: assId,
      metadata_list_id: mdlistId,
      entra_id: entraId,
    });
    return response.data;
  }

  if (assType === "experiment") {
    const response = await axios.post(API_ENDPOINTS.experimentMdlists, {
      node_id: assId,
      metadata_list_id: mdlistId,
      entra_id: entraId,
    });
    return response.data;
  }

  throw new Error(`Metadata list bindings are not supported for entity type: ${assType}`);
}

export async function detachMdListFromEntity(assType, assId, mdlistId, entraId) {
  if (assType === "record") {
    const response = await axios.delete(API_ENDPOINTS.recordMdlists, {
      data: {
        record_id: assId,
        metadata_list_id: mdlistId,
        entra_id: entraId,
      },
      headers: buildHeaders(entraId),
    });
    return response.data;
  }

  if (assType === "experiment") {
    const response = await axios.delete(API_ENDPOINTS.experimentMdlists, {
      data: {
        node_id: assId,
        metadata_list_id: mdlistId,
        entity_type: assType,
        entra_id: entraId,
      },
      headers: buildHeaders(entraId),
    });
    return response.data;
  }

  throw new Error(`Metadata list bindings are not supported for entity type: ${assType}`);
}
